"use client";

import type { ReactNode } from "react";
import Box from "@mui/material/Box";
import type { PayloadFooterConfig } from "@portal/app/_server/services/formFunnel/payloadTypes";
import { FormFunnelBannerImage } from "./FormFunnelBannerImage";

/** Layout of the active step. The page owns all supporting content. */
export function FormFunnelStepLayout({
  config,
  showBanner,
  pageOwnsContent = false,
  inline = false,
  children,
}: {
  config?: PayloadFooterConfig;
  showBanner: boolean;
  pageOwnsContent?: boolean;
  /** The landing page supplies the form's spacing and available width. */
  inline?: boolean;
  children: ReactNode;
}) {
  return (
    <Box sx={{ mt: inline ? 0 : pageOwnsContent && showBanner ? { xs: 0, md: 4 } : 4 }}>
      {showBanner && !pageOwnsContent && <FormFunnelBannerImage image={config?.bannerImage} />}
      <Box sx={{ width: "100%", maxWidth: inline ? "none" : 600, mx: "auto" }}>{children}</Box>
    </Box>
  );
}
